import * as FilterHelper from './FilterHelper';
import getIn from '../components/connectedForm/utils/getIn';

/**
 * @deprecated
 * Use hook variant functions from 'useActionProps', updating code to Function Components if necessary.
 */
export function getActionProps({ actionEntities, ...props }, type, overrideWorkspaceUrl) {
  const connectedForm = props.connectedForm || props;
  const state = getIn(connectedForm, 'location.state');

  let workspaceUrl = overrideWorkspaceUrl;
  if (state && state.path) {
    //Override the URL with the correct path to get entities
    //  - For example 'Product Templates' needs to override 'Products' when running global amendments.
    workspaceUrl = state.path;
  } else if (!workspaceUrl) {
    throw new Error('Workspace URL is not set.');
  } else {
    // remove any leading or trailing slashes
    workspaceUrl = workspaceUrl.replace(/^\/|\/$/g, '');
  }
  let actionFilters = props.workspaceFilters;
  if (!actionFilters) {
    if (state?.filters) {
      console.warn('Workspace Filters could not be found, falling back to state filter');
      actionFilters = state.filters;
    } else if (props.filters) {
      console.warn('Workspace Filters could not be found, falling back to props filter');
      actionFilters = props.filters;
    } else {
      console.error('Workspace Filters could not be found, falling back to getFilters');
      actionFilters = getFilters(props, workspaceUrl, connectedForm.dispatch);
    }
  }

  const selectionState = {
    filters: actionFilters,
    actionEntities: actionEntities || connectedForm.app.actionEntities,
    include: !props.selectedAll && !state?.selectedAll,
  };

  return formatActionProps(selectionState, type, workspaceUrl);
}

/**
 * @deprecated - Should not be required, use functions from 'useActionProps' to generate action criteria.
 */
export function formatActionProps(selectionState, type, workspaceUrl) {
  //Uncertain if we've already narrowed actionEntities down, so account for either.
  let actionEntities =
    (selectionState.actionEntities &&
      (selectionState.actionEntities[workspaceUrl] || selectionState.actionEntities[`/${workspaceUrl}`])) ||
    (Array.isArray(selectionState.actionEntities) && selectionState.actionEntities) ||
    undefined;

  if (!actionEntities || Object.keys(actionEntities).length === 0) {
    actionEntities = [];
  }

  return {
    filters: selectionState.filters,
    [`${type}`]: actionEntities,
    include: !!selectionState.include,
  };
}

/**
 * @deprecated - Used exclusively for deprecated functions.
 */
function getFilters(props, workspaceUrl) {
  const view =
    props.view ||
    (props.views && props.views[workspaceUrl] ? props.views[workspaceUrl].currentView : null) ||
    (props.extraData && props.extraData.views ? props.extraData.views[workspaceUrl] : null) ||
    {};

  return FilterHelper.getFilters(view, null, null, props.views?.[workspaceUrl]?.availableColumns ?? []);
}
